module.exports = __webpack_public_path__ + "yeni fransa mutfak 13.jpg?aa640fb5d714bc926c9b93c3af1c0de4";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa mutfak 13.jpg
// module id = 379
// module chunks = 0